(function ($) {
  $(function () {
    var attribution = captureAttribution();
    var $flow = $('[data-angebot-flow]');

    if (!$flow.length) {
      return;
    } 
 
	    $flow.each(function () {
	      var $instance = $(this);
	      var $form = $instance.find('[data-angebot-form]');
      var $steps = $form.find('[data-step]');
      var $success = $form.find('[data-success-state]');
      var $indicator = $instance.find('[data-step-indicator]');
      var $title = $instance.find('[data-current-step-title]');
      var $header = $instance.find('.angebot-flow__header');
      var $next = $form.find('[data-step-next]');
      var $submit = $form.find('[data-step-submit]');
	      var $back = $form.find('[data-step-back]');
	      var $nav = $form.find('[data-form-navigation]');
	      var $error = $form.find('[data-form-error]');
	      var ajaxUrl = $instance.data('ajax-url');
	      var nonce = $instance.data('nonce');
	      var currentStep = 0;
	      var totalSteps = parseInt($instance.data('total-steps'), 10) || $steps.length;

      populateAttributionFields($form, attribution);
	      var electricityConsumptionOptions = {
	        privathaushalt: [
	          {
	            value: 'bis_1500',
	            label: 'bis 1.500 kWh'
	          },
	          {
	            value: '1500_2500',
	            label: '1.500&ndash;2.500 kWh'
	          },
	          {
	            value: '2500_4000',
	            label: '2.500&ndash;4.000 kWh'
	          },
	          {
	            value: 'ueber_4000',
	            label: '&uuml;ber 4.000 kWh'
	          }
	        ],
	        gewerbe: [
	          {
	            value: 'bis_25000',
	            label: 'Bis 25.000 kWh'
	          },
	          {
	            value: 'bis_100000',
	            label: 'Bis 100.000 kWh'
	          },
	          {
	            value: 'bis_500000',
	            label: 'Bis 500.000 kWh'
	          },
	          {
	            value: 'ueber_1000000',
	            label: 'Gr&ouml;&szlig;er als 1.000.000 kWh'
	          }
	        ]
	      };

	      function getInterestType() {
	        return $form.find('input[name="interest_type"]:checked').val() || '';
	      }

	      function shouldSkipStep($step) {
	        var stepId = $step.data('step-id');

	        return getInterestType() === 'waermepumpe' && (stepId === 'storage_interest' || stepId === 'wallbox_interest');
	      }

	      function getActiveStepIndexes() {
	        var indexes = [];

	        $steps.each(function (index) {
	          if (!shouldSkipStep($(this))) {
	            indexes.push(index);
	          }
	        });

	        return indexes;
	      }

	      function getAdjacentStepIndex(direction) {
	        var indexes = getActiveStepIndexes();
	        var position = indexes.indexOf(currentStep);

	        return indexes[position + direction];
	      }

	      function updateHeader() {
	        var $current = $steps.eq(currentStep);
	        var currentTitle = $current.data('step-heading') || '';
	        var activeIndexes = getActiveStepIndexes();
	        var currentPosition = activeIndexes.indexOf(currentStep);

	        totalSteps = activeIndexes.length;
	        $indicator.text((currentPosition + 1) + '/' + totalSteps);
        $title.text(currentTitle);
      }

	      function updateButtons() {
	        var $current = $steps.eq(currentStep);
	        var activeIndexes = getActiveStepIndexes();
	        var isLast = currentStep === activeIndexes[activeIndexes.length - 1];
	        var stepType = $current.data('step-type');

	        $back.prop('disabled', currentStep === activeIndexes[0]);
	        $next.attr('hidden', isLast || stepType === 'cards');
	        $submit.attr('hidden', !isLast);
	      }

	      function updateElectricityConsumptionOptions(propertyType) {
	        var options = electricityConsumptionOptions[propertyType] || electricityConsumptionOptions.gewerbe;
	        var $consumptionStep = $form.find('input[name="annual_electricity_consumption"]').first().closest('[data-step]');
	        var $optionItems = $consumptionStep.find('.angebot-option');

	        $optionItems.each(function (index) {
	          var option = options[index];
	          var $option = $(this);

	          if (!option) {
	            return;
	          }

	          $option.find('input[type="radio"]').val(option.value).prop('checked', false);
	          $option.find('.angebot-option__text').html(option.label);
	        });
	      }

      function showError(message) {
        $error.text(message).prop('hidden', false);
      }

	      function clearError() {
	        $error.prop('hidden', true).text('');
	      }

	      function getFieldMessage(field) {
	        if (field.validity.valueMissing) {
	          return 'Bitte füllen Sie dieses Feld aus.';
	        }

	        if (field.validity.typeMismatch) {
	          return 'Bitte geben Sie eine gueltige E-Mail-Adresse ein.';
	        }

	        return 'Bitte pruefen Sie dieses Feld.';
	      }

	      function clearFieldError($field) {
	        $field.removeClass('is-invalid');
	        $field.find('input, textarea').attr('aria-invalid', 'false');
	        $field.find('[data-field-error]').prop('hidden', true);
	      }

	      function showFieldError($input) {
	        var $field = $input.closest('.angebot-field');
	        var $fieldError = $field.find('[data-field-error]').first();

	        if (!$fieldError.length) {
	          return;
	        }

	        $field.addClass('is-invalid');
	        $input.attr('aria-invalid', 'true');
	        $fieldError.text(getFieldMessage($input.get(0))).prop('hidden', false);
	      }

	      function clearStepFieldErrors($step) {
	        $step.find('.angebot-field').each(function () {
	          clearFieldError($(this));
	        });
	      }

	      function validateStep() {
	        var $current = $steps.eq(currentStep);
	        var stepType = $current.data('step-type');

	        clearError();

	        if (stepType === 'contact' || stepType === 'input') {
	          var valid = true;
	          clearStepFieldErrors($current);

	          $current.find('input[required], textarea[required]').each(function () {
	            if (!this.checkValidity()) {
	              valid = false;
	              showFieldError($(this));
	            }
	          });

	          return valid;
	        }

        if (!$current.find('input[type="radio"]:checked').length) {
          showError('Bitte waehlen Sie eine Option aus, um fortzufahren.');
          return false;
        }

        return true;
      }

	      function activateStep(stepIndex) {
	        if (typeof stepIndex === 'undefined') {
	          return;
	        }

	        currentStep = stepIndex;

	        $steps.each(function (index) {
	          var $step = $(this);
	          var isActive = index === stepIndex;

	          $step.toggleClass('is-active', isActive);
	          $step.toggleClass('is-hidden', !isActive);
	        });

	        updateHeader();
	        updateButtons();
	        clearError();
	      }

      function collectAnswers() {
        var payload = {
          action: 'submit_angebot_form',
          nonce: nonce
        };

        $.each($form.serializeArray(), function (_, field) {
          payload[field.name] = field.value;
        });

        return payload;
      }

	      function showSuccess() {
	        $steps.addClass('is-hidden').removeClass('is-active');
	        $success.removeClass('is-hidden');
        $nav.addClass('is-hidden');
        $header.prop('hidden', true);
        clearError();
      }

	      $form.on('input change', 'input, textarea', function () {
	        var $input = $(this);
	        var $field = $input.closest('.angebot-field');
	        clearError();

	        if ($field.hasClass('is-invalid')) {
	          if (this.checkValidity()) {
	            clearFieldError($field);
	          } else {
	            showFieldError($input);
	          }
	        }
	      });

	      $form.on('change', 'input[name="interest_type"]', function () {
	        if (this.value === 'waermepumpe') {
	          $form.find('input[name="storage_interest"], input[name="wallbox_interest"]').prop('checked', false);
	        }

	        updateHeader();
	        updateButtons();
	      });

	      $form.on('change', '.angebot-step[data-step-type="cards"] input[type="radio"]', function () {
	        if (!validateStep()) {
	          return;
	        }

	        if (this.name === 'property_type') {
	          updateElectricityConsumptionOptions(this.value);
	        }

	        window.setTimeout(function () {
	          activateStep(getAdjacentStepIndex(1));
        }, 180);
      });

	      $next.on('click', function () {
	        if (!validateStep()) {
	          return;
	        }

	        activateStep(getAdjacentStepIndex(1));
	      });

	      $back.on('click', function () {
	        var previousStep = getAdjacentStepIndex(-1);

	        if (typeof previousStep === 'undefined') {
	          return;
	        }

	        activateStep(previousStep);
      });

      $form.on('submit', function (event) {
        event.preventDefault();

        if (!validateStep()) {
          return;
        }

        var payload = collectAnswers();

        $submit.prop('disabled', true).text('Wird gesendet...');
        clearError();

        $.post(ajaxUrl, payload)
          .done(function (response) {
            if (response && response.success) {
              showSuccess();
              return;
            }

            showError(response && response.data && response.data.message ? response.data.message : 'Beim Senden ist ein Fehler aufgetreten.');
          })
          .fail(function () {
            showError('Die Anfrage konnte gerade nicht gesendet werden. Bitte versuchen Sie es erneut.');
          })
          .always(function () {
            $submit.prop('disabled', false).text('Angebot anfragen');
          });
      });

	      activateStep(0);
	    });
	  });

  var attributionStorageKey = 'dd_angebot_attribution_v1';
  var attributionLifetime = 90 * 24 * 60 * 60 * 1000;
  var attributionKeys = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'gclid',
    'fbclid'
  ];

  function getStoredAttribution() {
    try {
      var stored = window.localStorage.getItem(attributionStorageKey);
      var attribution = stored ? JSON.parse(stored) : null;

      if (!attribution || !attribution.expiresAt || attribution.expiresAt < Date.now()) {
        window.localStorage.removeItem(attributionStorageKey);
        return null;
      }

      return attribution;
    } catch (error) {
      return null;
    }
  }

  function storeAttribution(attribution) {
    try {
      window.localStorage.setItem(attributionStorageKey, JSON.stringify(attribution));
    } catch (error) {
      // Tracking must never prevent the form from working.
    }
  }

  function getCurrentTouch() {
    var touch = {
      landing_page: window.location.href,
      referrer: document.referrer || '',
      captured_at: new Date().toISOString()
    };
    var hasCampaignData = false;

    $.each(attributionKeys, function (_, key) {
      var value = getQueryParameter(key);
      touch[key] = value.substring(0, 255);
      hasCampaignData = hasCampaignData || value !== '';
    });

    touch.has_campaign_data = hasCampaignData;
    return touch;
  }

  function getQueryParameter(parameterName) {
    var query = window.location.search.substring(1).split('&');
    var value = '';

    $.each(query, function (_, pair) {
      var parts = pair.split('=');
      var key;

      try {
        key = decodeURIComponent((parts.shift() || '').replace(/\+/g, ' '));
      } catch (error) {
        key = '';
      }

      if (key !== parameterName) {
        return;
      }

      try {
        value = decodeURIComponent(parts.join('=').replace(/\+/g, ' '));
      } catch (error) {
        value = '';
      }

      return false;
    });

    return value;
  }

  function captureAttribution() {
    var stored = getStoredAttribution();
    var currentTouch = getCurrentTouch();

    if (!stored) {
      stored = {
        first: currentTouch,
        last: currentTouch,
        expiresAt: Date.now() + attributionLifetime
      };
      storeAttribution(stored);
      return stored;
    }

    if (currentTouch.has_campaign_data) {
      stored.last = currentTouch;
      stored.expiresAt = Date.now() + attributionLifetime;
      storeAttribution(stored);
    }

    return stored;
  }

  function populateAttributionFields($form, attribution) {
    if (!attribution) {
      return;
    }

    $.each(['first', 'last'], function (_, touchType) {
      var touch = attribution[touchType] || {};
      var fields = attributionKeys.concat(['landing_page', 'referrer', 'captured_at']);

      $.each(fields, function (__, fieldName) {
        var inputName = touchType + '_' + fieldName;
        var $input = $form.find('input[name="' + inputName + '"]');

        if (!$input.length) {
          $input = $('<input>', {
            type: 'hidden',
            name: inputName
          }).appendTo($form);
        }

        $input.val(touch[fieldName] || '');
      });
    });
  }
	})(jQuery);
